"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_final_form_1 = require("react-final-form");
const FormControl_1 = __importDefault(require("@mui/material/FormControl"));
const FormHelperText_1 = __importDefault(require("@mui/material/FormHelperText"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const InputAdornment_1 = __importDefault(require("@mui/material/InputAdornment"));
const InputLabel_1 = __importDefault(require("@mui/material/InputLabel"));
const OutlinedInput_1 = __importDefault(require("@mui/material/OutlinedInput"));
const Visibility_1 = __importDefault(require("@mui/icons-material/Visibility"));
const VisibilityOff_1 = __importDefault(require("@mui/icons-material/VisibilityOff"));
const PasswordField = ({ name, label, validate, disabled }) => {
    const [showPassword, setShowPassword] = (0, react_1.useState)(false);
    return (react_1.default.createElement(react_final_form_1.Field, { name: name, validate: validate }, ({ input, meta }) => (react_1.default.createElement(FormControl_1.default, { variant: "outlined", sx: { width: '100%' } },
        react_1.default.createElement(InputLabel_1.default, null, label),
        react_1.default.createElement(OutlinedInput_1.default, { ...input, disabled: disabled, error: meta.touched && meta.error, endAdornment: react_1.default.createElement(InputAdornment_1.default, { position: "end" },
                react_1.default.createElement(IconButton_1.default, { "aria-label": "toggle password visibility", onClick: () => setShowPassword(!showPassword), edge: "end" }, showPassword ? react_1.default.createElement(Visibility_1.default, null) : react_1.default.createElement(VisibilityOff_1.default, null))), label: label, name: name, type: showPassword ? 'text' : 'password' }),
        react_1.default.createElement(FormHelperText_1.default, { error: true }, meta.touched && meta.error)))));
};
exports.default = PasswordField;
